import { useState, useEffect } from "react";

import { API } from "../config";
const FONT = "'DM Sans', sans-serif";

const LEGHE = [
  "Belgian First Division A",
  "Dutch Eredivisie",
  "English Championship",
  "English Premier League",
  "French Ligue 1",
  "German Bundesliga",
  "German Bundesliga 2",
  "Italian Serie A",
  "Portuguese Primeira Liga",
  "Spanish La Liga",
  "Turkish Super League",
];

const S = {
  pagina: { padding: "24px 32px", fontFamily: FONT, background: "#F8FAFC", minHeight: "100vh" },
  tabBar: { display: "flex", gap: 8, marginBottom: 28, flexWrap: "wrap" },
  tab: (attiva) => ({
    padding: "10px 20px", borderRadius: 8, fontSize: 13, fontWeight: 600,
    cursor: "pointer", fontFamily: FONT,
    background: attiva ? "#2563EB" : "#fff",
    color: attiva ? "#fff" : "#64748B",
    boxShadow: attiva ? "0 2px 8px rgba(37,99,235,0.25)" : "0 1px 3px rgba(0,0,0,0.08)",
    border: attiva ? "1px solid #2563EB" : "1px solid #E2E8F0",
    transition: "all 0.15s",
  }),
  card: {
    background: "#fff", borderRadius: 12, padding: "24px",
    marginBottom: 20, boxShadow: "0 1px 4px rgba(0,0,0,0.06)",
    border: "1px solid #E2E8F0",
  },
  guidaBox: {
    background: "#F0F7FF", border: "1px solid #BFDBFE", borderRadius: 8,
    padding: "12px 16px", marginBottom: 20, fontSize: 12, color: "#1E3A5F", lineHeight: 1.7,
  },
  titoloSez: { fontSize: 14, fontWeight: 700, color: "#1E293B", marginBottom: 4 },
  sottotitoloSez: { fontSize: 12, color: "#64748B", lineHeight: 1.6 },
  tabella: { width: "100%", borderCollapse: "collapse", fontSize: 13 },
  th: {
    background: "#F1F5F9", color: "#475569", fontWeight: 600,
    padding: "9px 14px", textAlign: "left", borderBottom: "2px solid #E2E8F0", fontSize: 12,
  },
  td: { padding: "9px 14px", borderBottom: "1px solid #F1F5F9", color: "#1E293B", fontSize: 13 },
  tdSpenta: { padding: "9px 14px", borderBottom: "1px solid #F1F5F9", color: "#94A3B8", fontSize: 13 },
  tdAzioni: { padding: "7px 14px", borderBottom: "1px solid #F1F5F9", whiteSpace: "nowrap" },
  gruppo: { border: "1px solid #E2E8F0", borderRadius: 8, marginBottom: 8, overflow: "hidden" },
  gruppoHdr: {
    display: "flex", alignItems: "center", gap: 8, padding: "10px 14px",
    background: "#F8FAFC", cursor: "pointer", fontSize: 13,
  },
  gruppoNome: { fontWeight: 700, color: "#1E293B" },
  gruppoInfo: { color: "#64748B" },
  vuoto: { fontSize: 12, color: "#94A3B8", fontStyle: "italic" },
  btnModifica: {
    fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 5,
    border: "1px solid #BFDBFE", background: "#EFF6FF", color: "#2563EB",
    cursor: "pointer", marginRight: 6,
  },
  btnElimina: {
    fontSize: 11, fontWeight: 600, padding: "4px 10px", borderRadius: 5,
    border: "1px solid #FECACA", background: "#FEF2F2", color: "#DC2626", cursor: "pointer",
  },
  btnSalva: {
    fontSize: 12, fontWeight: 600, padding: "6px 14px", borderRadius: 6,
    border: "none", background: "#16A34A", color: "#fff", cursor: "pointer", marginRight: 6,
  },
  btnAnnulla: {
    fontSize: 12, fontWeight: 600, padding: "6px 14px", borderRadius: 6,
    border: "1px solid #E2E8F0", background: "#fff", color: "#64748B", cursor: "pointer",
  },
  btnAggiungi: {
    fontSize: 13, fontWeight: 600, padding: "9px 18px", borderRadius: 7,
    border: "none", background: "#2563EB", color: "#fff", cursor: "pointer", whiteSpace: "nowrap",
  },
  input: {
    fontSize: 12, padding: "6px 9px", borderRadius: 5,
    border: "1px solid #CBD5E1", fontFamily: FONT, width: "100%", boxSizing: "border-box",
  },
  select: {
    fontSize: 12, padding: "6px 9px", borderRadius: 5,
    border: "1px solid #CBD5E1", fontFamily: FONT, width: "100%", background: "#fff",
  },
  msgOk: { fontSize: 12, color: "#16A34A", fontWeight: 600, marginTop: 10 },
  msgErr: { fontSize: 12, color: "#DC2626", fontWeight: 600, marginTop: 10 },
  overlay: {
    position: "fixed", inset: 0, background: "rgba(15,23,42,0.55)",
    display: "flex", alignItems: "center", justifyContent: "center",
    padding: 24, zIndex: 1000,
  },
  modal: {
    background: "#fff", borderRadius: 12, padding: "22px 26px",
    maxWidth: 520, width: "100%", maxHeight: "90vh", overflowY: "auto",
    fontFamily: FONT, boxShadow: "0 10px 40px rgba(0,0,0,0.2)",
  },
  modalTitolo: { fontSize: 16, fontWeight: 700, color: "#1E293B", marginBottom: 6 },
  modalSub: { fontSize: 13, color: "#64748B", marginBottom: 16 },
  modalBox: {
    background: "#F8FAFC", borderRadius: 8, padding: "12px 14px",
    marginBottom: 14, fontSize: 13, color: "#1E293B", lineHeight: 1.6,
  },
  modalNota: {
    display: "flex", gap: 9, alignItems: "flex-start",
    fontSize: 13, color: "#64748B", lineHeight: 1.6, marginBottom: 10,
  },
};

// ─── Banner di richiamo a Setup nuova stagione (D356) ────────────────────────

function BannerRichiamoSetup({ testo, onNavigate }) {
  return (
    <div style={{
      background: "#EBF4FC",
      border: "1px solid #93C0EB",
      borderRadius: 8,
      padding: "12px 16px",
      marginBottom: 16,
      display: "flex",
      alignItems: "flex-start",
      gap: 10,
      fontFamily: FONT,
    }}>
      <span style={{
        fontSize: 18,
        lineHeight: 1,
        color: "#1D6FBC",
        flexShrink: 0,
        marginTop: 1,
      }}>ⓘ</span>
      <div style={{ fontSize: 12, lineHeight: 1.7, color: "#0C447C" }}>
        {testo}{" "}
        <span
          onClick={() => onNavigate && onNavigate("setup-stagione")}
          style={{
            cursor: "pointer",
            textDecoration: "underline",
            fontWeight: 700,
            color: "#0C447C",
            whiteSpace: "nowrap",
          }}
        >→ Vai a Setup nuova stagione</span>
      </div>
    </div>
  );
}

// ─── Sezione 1: Numero squadre ───────────────────────────────────────────────

function SezioneNumSquadre({ onNavigate }) {
  const [campionati, setCampionati] = useState([]);
  const [storico, setStorico] = useState([]);
  const [giocate, setGiocate] = useState({});
  const [gruppiAperti, setGruppiAperti] = useState({});

  const [editStdId, setEditStdId] = useState(null);
  const [editStdVal, setEditStdVal] = useState("");
  const [conferma, setConferma] = useState(null);

  const [editRigaId, setEditRigaId] = useState(null);
  const [editRigaVal, setEditRigaVal] = useState("");

  const [mostraForm, setMostraForm] = useState(false);
  const [nuova, setNuova] = useState({ campionato_id: "", stagione: "", num_squadre: "" });

  const [msg, setMsg] = useState("");
  const [msgErr, setMsgErr] = useState("");

  const caricaTutto = () => {
    fetch(`${API}/impostazioni/num-squadre`).then(r => r.json()).then(setCampionati);
    fetch(`${API}/impostazioni/storico-num-squadre`).then(r => r.json()).then(setStorico);
    fetch(`${API}/impostazioni/stagioni-giocate`).then(r => r.json()).then(setGiocate);
  };

  useEffect(() => { caricaTutto(); }, []);

  useEffect(() => {
    if (!conferma) return;
    const onEsc = (e) => { if (e.key === "Escape") setConferma(null); };
    window.addEventListener("keydown", onEsc);
    return () => window.removeEventListener("keydown", onEsc);
  }, [conferma]);

  const flash = (testo, errore) => {
    if (errore) { setMsgErr(testo); setTimeout(() => setMsgErr(""), 5000); }
    else { setMsg(testo); setTimeout(() => setMsg(""), 3000); }
  };

  const nomeDaId = (id) => {
    const c = campionati.find(x => x.id === Number(id));
    return c ? c.nome_bf : "";
  };

  const bloccata = (campionatoId, stagione) => {
    const elenco = giocate[nomeDaId(campionatoId)] || [];
    return elenco.includes(stagione);
  };

  // ── Valore standard ────────────────────────────────────────────────────────

  const chiediConfermaStandard = async (c) => {
    const n = parseInt(editStdVal);
    if (!n || n < 1) { flash("Valore non valido", true); return; }
    if (n === c.num_squadre) { setEditStdId(null); return; }
    try {
      const r = await fetch(`${API}/impostazioni/num-squadre/${c.id}/anteprima?nuovo=${n}`);
      const d = await r.json();
      setConferma({ ...d, campionato_id: c.id });
    } catch (e) {
      flash("Non riesco a calcolare le conseguenze del cambio", true);
    }
  };

  const applicaCambioStandard = async () => {
    const { campionato_id, valore_nuovo, stagioni_da_registrare } = conferma;
    await fetch(`${API}/impostazioni/num-squadre/${campionato_id}`, {
      method: "PUT", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ num_squadre: valore_nuovo }),
    });
    setConferma(null);
    setEditStdId(null);
    caricaTutto();
    const q = stagioni_da_registrare.length;
    flash(q > 0
      ? `✅ Standard aggiornato. Registrate ${q} stagioni già giocate.`
      : "✅ Standard aggiornato.");
  };

  // ── Righe stagione ─────────────────────────────────────────────────────────

  const salvaRiga = async (riga) => {
    const n = parseInt(editRigaVal);
    if (!n || n < 1) { flash("Valore non valido", true); return; }
    const r = await fetch(`${API}/impostazioni/storico-num-squadre/${riga.id}`, {
      method: "PUT", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ num_squadre: n }),
    });
    if (!r.ok) { flash("Questa stagione ha già partite: non è più modificabile", true); return; }
    setEditRigaId(null);
    caricaTutto();
    flash("✅ Salvato");
  };

  const eliminaRiga = async (riga, nomeLega) => {
    if (!window.confirm(`Togliere ${nomeLega} ${riga.stagione}? Tornerà a usare il valore standard.`)) return;
    const r = await fetch(`${API}/impostazioni/storico-num-squadre/${riga.id}`, { method: "DELETE" });
    if (!r.ok) { flash("Questa stagione ha già partite: non è più eliminabile", true); return; }
    caricaTutto();
    flash("✅ Eliminato");
  };

  const aggiungiRiga = async () => {
    const { campionato_id, stagione, num_squadre } = nuova;
    if (!campionato_id || !stagione || !num_squadre) { flash("Compila tutti i campi", true); return; }
    if (!/^\d{2}-\d{2}$/.test(stagione)) { flash("Formato stagione: XX-YY (es. 26-27)", true); return; }
    if (bloccata(campionato_id, stagione)) {
      flash("Questa stagione ha già partite a database: il valore non è più modificabile", true);
      return;
    }
    const gia = storico.find(s => s.campionato_id === Number(campionato_id) && s.stagione === stagione);
    if (gia) { flash("Questa stagione ha già un valore proprio: correggilo dall'elenco", true); return; }
    const r = await fetch(`${API}/impostazioni/storico-num-squadre`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        campionato_id: parseInt(campionato_id),
        stagione,
        num_squadre: parseInt(num_squadre),
      }),
    });
    if (!r.ok) { flash("Questa stagione ha già partite: non è più modificabile", true); return; }
    setNuova({ campionato_id: "", stagione: "", num_squadre: "" });
    setMostraForm(false);
    caricaTutto();
    setGruppiAperti(s => ({ ...s, [Number(campionato_id)]: true }));
    flash("✅ Stagione aggiunta");
  };

  // ── Raggruppamento ─────────────────────────────────────────────────────────

  const gruppi = campionati
    .map(c => ({
      ...c,
      righe: storico
        .filter(s => s.campionato_id === c.id)
        .sort((a, b) => b.stagione.localeCompare(a.stagione)),
    }))
    .filter(g => g.righe.length > 0);

  return (
    <div>
      <BannerRichiamoSetup
        testo={<><strong>Qui si esegue la Fase 2 della procedura di setup.</strong> Quando hai finito, segna la fase come fatta in Setup nuova stagione.</>}
        onNavigate={onNavigate}
      />
      <div style={S.guidaBox}>
        <strong>A cosa serve:</strong> il numero di squadre serve a calcolare le fasce di classifica (Alta, Media-Alta, Media-Bassa, Bassa) di ogni squadra prima di ogni partita.<br /><br />
        <strong>Quando aggiornare:</strong> a inizio stagione, se un campionato cambia numero di squadre. Nel dubbio aggiungi la stagione: costa una riga e non tocca nulla. Passa al valore standard quando il nuovo numero si ripete di anno in anno.
      </div>

      {/* Valori standard */}
      <div style={S.card}>
        <div style={S.titoloSez}>Valori standard</div>
        <div style={{ ...S.sottotitoloSez, marginBottom: 16 }}>
          Vale per tutte le stagioni, tranne quelle elencate nel riquadro "Stagioni con valori diversi da standard".
        </div>
        <table style={S.tabella}>
          <thead>
            <tr>
              <th style={S.th}>Campionato</th>
              <th style={S.th}>N° Squadre</th>
              <th style={S.th}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {campionati.map(c => (
              <tr key={c.id}>
                <td style={S.td}>{c.nome_bf}</td>
                <td style={S.td}>
                  {editStdId === c.id
                    ? <input style={{ ...S.input, width: 70 }} type="number" value={editStdVal}
                        onChange={e => setEditStdVal(e.target.value)} />
                    : <strong>{c.num_squadre}</strong>}
                </td>
                <td style={S.tdAzioni}>
                  {editStdId === c.id ? (
                    <>
                      <button style={S.btnSalva} onClick={() => chiediConfermaStandard(c)}>Salva</button>
                      <button style={S.btnAnnulla} onClick={() => setEditStdId(null)}>Annulla</button>
                    </>
                  ) : (
                    <button style={S.btnModifica}
                      onClick={() => { setEditStdId(c.id); setEditStdVal(c.num_squadre); }}>✏️ Modifica</button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Stagioni con valori diversi da standard */}
      <div style={S.card}>
        <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: 16, marginBottom: 16 }}>
          <div>
            <div style={S.titoloSez}>Stagioni con valori diversi da standard</div>
            <div style={S.sottotitoloSez}>
              Qui il valore standard non si applica. Una stagione si può correggere o togliere finché non ha partite.
            </div>
          </div>
          {!mostraForm && (
            <button style={S.btnAggiungi} onClick={() => setMostraForm(true)}>+ Aggiungi stagione</button>
          )}
        </div>

        {mostraForm && (
          <div style={{ background: "#F8FAFC", borderRadius: 8, padding: 16, border: "1px solid #E2E8F0", marginBottom: 16 }}>
            <div style={{ fontSize: 13, fontWeight: 600, color: "#1E293B", marginBottom: 12 }}>Nuova stagione</div>
            <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" }}>
              <div style={{ flex: 2, minWidth: 160 }}>
                <div style={{ fontSize: 11, color: "#64748B", marginBottom: 3 }}>Campionato</div>
                <select style={S.select} value={nuova.campionato_id}
                  onChange={e => setNuova(n => ({ ...n, campionato_id: e.target.value }))}>
                  <option value="">— Seleziona —</option>
                  {campionati.map(c => <option key={c.id} value={c.id}>{c.nome_bf}</option>)}
                </select>
              </div>
              <div style={{ flex: 1, minWidth: 100 }}>
                <div style={{ fontSize: 11, color: "#64748B", marginBottom: 3 }}>Stagione (es. 26-27)</div>
                <input style={S.input} placeholder="26-27" value={nuova.stagione}
                  onChange={e => setNuova(n => ({ ...n, stagione: e.target.value }))} />
              </div>
              <div style={{ flex: 1, minWidth: 80 }}>
                <div style={{ fontSize: 11, color: "#64748B", marginBottom: 3 }}>N° Squadre</div>
                <input style={S.input} type="number" placeholder="18" value={nuova.num_squadre}
                  onChange={e => setNuova(n => ({ ...n, num_squadre: e.target.value }))} />
              </div>
            </div>
            <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
              <button style={S.btnSalva} onClick={aggiungiRiga}>Aggiungi</button>
              <button style={S.btnAnnulla} onClick={() => setMostraForm(false)}>Annulla</button>
            </div>
          </div>
        )}

        {gruppi.length === 0 ? (
          <div style={S.vuoto}>Nessuna stagione con valore diverso dallo standard.</div>
        ) : gruppi.map(g => {
          const aperto = !!gruppiAperti[g.id];
          const tutteGiocate = g.righe.every(r => bloccata(g.id, r.stagione));
          const n = g.righe.length;
          return (
            <div key={g.id} style={S.gruppo}>
              <div style={S.gruppoHdr}
                onClick={() => setGruppiAperti(s => ({ ...s, [g.id]: !aperto }))}>
                <span style={{ color: "#64748B" }}>{aperto ? "▼" : "▶"}</span>
                <span style={S.gruppoNome}>{g.nome_bf}</span>
                <span style={S.gruppoInfo}>
                  standard {g.num_squadre} · {n} {n === 1 ? "stagione diversa" : "stagioni diverse"}
                  {tutteGiocate ? ", tutte giocate" : ""}
                </span>
              </div>
              {aperto && (
                <table style={S.tabella}>
                  <tbody>
                    {g.righe.map(r => {
                      const bl = bloccata(g.id, r.stagione);
                      const inEdit = editRigaId === r.id;
                      const stile = bl ? S.tdSpenta : S.td;
                      return (
                        <tr key={r.id}>
                          <td style={{ ...stile, width: 110 }}>{r.stagione}</td>
                          <td style={{ ...stile, width: 140 }}>
                            {inEdit
                              ? <input style={{ ...S.input, width: 70 }} type="number" value={editRigaVal}
                                  onChange={e => setEditRigaVal(e.target.value)} />
                              : <strong>{r.num_squadre} squadre</strong>}
                          </td>
                          <td style={S.tdSpenta}>{bl ? "giocata" : "non ancora iniziata"}</td>
                          <td style={{ ...S.tdAzioni, textAlign: "right" }}>
                            {bl ? (
                              <span style={{ color: "#94A3B8", fontSize: 13 }}
                                title="La stagione ha già partite: le fasce sono state calcolate con questo numero">🔒</span>
                            ) : inEdit ? (
                              <>
                                <button style={S.btnSalva} onClick={() => salvaRiga(r)}>Salva</button>
                                <button style={S.btnAnnulla} onClick={() => setEditRigaId(null)}>Annulla</button>
                              </>
                            ) : (
                              <>
                                <button style={S.btnModifica}
                                  onClick={() => { setEditRigaId(r.id); setEditRigaVal(r.num_squadre); }}>✏️ Modifica</button>
                                <button style={S.btnElimina}
                                  onClick={() => eliminaRiga(r, g.nome_bf)}>🗑 Elimina</button>
                              </>
                            )}
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
            </div>
          );
        })}

        {msg && <div style={S.msgOk}>{msg}</div>}
        {msgErr && <div style={S.msgErr}>{msgErr}</div>}
      </div>

      {/* Conferma cambio valore standard */}
      {conferma && (
        <div style={S.overlay} onClick={() => setConferma(null)}>
          <div style={S.modal} onClick={e => e.stopPropagation()}>
            <div style={S.modalTitolo}>Cambiare il valore standard di {conferma.campionato}?</div>
            <div style={S.modalSub}>
              Da {conferma.valore_attuale} a {conferma.valore_nuovo} squadre.
            </div>

            {conferma.stagioni_da_registrare.length > 0 && (
              <div style={S.modalBox}>
                <div style={{ marginBottom: 8 }}>
                  Per non alterare il passato, registro {conferma.stagioni_da_registrare.length}{" "}
                  {conferma.stagioni_da_registrare.length === 1 ? "stagione già giocata" : "stagioni già giocate"}{" "}
                  con il valore attuale, {conferma.valore_attuale}:
                </div>
                <div style={{ color: "#64748B" }}>
                  {conferma.stagioni_da_registrare.join(" · ")}
                </div>
              </div>
            )}

            {conferma.stagioni_gia_proprie.length > 0 && (
              <div style={S.modalNota}>
                <span>🔒</span>
                <div>
                  Le stagioni {conferma.stagioni_gia_proprie.join(", ")} hanno già un valore proprio e restano come sono.
                </div>
              </div>
            )}

            <div style={{ ...S.modalNota, marginBottom: 20 }}>
              <span>→</span>
              <div>
                Dalle stagioni successive vale {conferma.valore_nuovo}, salvo quelle con un valore proprio.
              </div>
            </div>

            <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
              <button style={S.btnAnnulla} onClick={() => setConferma(null)}>Annulla</button>
              <button style={S.btnSalva} onClick={applicaCambioStandard}>Cambia e registra</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

// ─── Sezione mapping generica ────────────────────────────────────────────────

function SezioneMapping({ guida, bannerTesto, endpoint, colonne, campiForm, campiLabels, onNavigate }) {
  const [righe, setRighe] = useState([]);
  const [legheAperte, setLegheAperte] = useState({});
  const [filtroLega, setFiltroLega] = useState("Tutti");
  const [editId, setEditId] = useState(null);
  const [editVals, setEditVals] = useState({});
  const [nuovoForm, setNuovoForm] = useState({});
  const [mostraForm, setMostraForm] = useState(false);
  const [msg, setMsg] = useState("");
  const [nomiDb, setNomiDb] = useState([]);

  useEffect(() => {
    fetch(`${API}${endpoint}`).then(r => r.json()).then(setRighe);
    const init = {};
    campiForm.forEach(f => { init[f] = ""; });
    setNuovoForm(init);
  }, [endpoint]);

  // Nomi squadra realmente presenti nel campionato scelto: alimentano
  // l'avviso quando il "Nome nel database" scritto a mano non esiste.
  useEffect(() => {
    const l = nuovoForm.lega;
    if (!l) { setNomiDb([]); return; }
    let annullato = false;
    fetch(`${API}/squadre/nomi-db?lega=${encodeURIComponent(l)}`)
      .then(r => r.json())
      .then(d => { if (!annullato && d && Array.isArray(d.nomi)) setNomiDb(d.nomi); })
      .catch(() => {});
    return () => { annullato = true; };
  }, [nuovoForm.lega]);

  // v208: uno spazio o una tabulazione invisibile ai bordi di un nome fa
  // nascere una squadra diversa a database. Si toglie in silenzio al
  // salvataggio; gli spazi interni (es. "Erzurum BB") restano intatti.
  const pulisciValori = (o) => {
    const out = {};
    Object.keys(o).forEach(k => {
      out[k] = typeof o[k] === "string" ? o[k].trim() : o[k];
    });
    return out;
  };

  const salva = async (id) => {
    const vals = pulisciValori(editVals);
    await fetch(`${API}${endpoint}/${id}`, {
      method: "PUT", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(vals),
    });
    setRighe(r => r.map(x => x.id === id ? { ...x, ...vals } : x));
    setEditId(null);
    setMsg("✅ Salvato");
    setTimeout(() => setMsg(""), 3000);
  };

  const elimina = async (id) => {
    if (!window.confirm("Eliminare questa voce?")) return;
    await fetch(`${API}${endpoint}/${id}`, { method: "DELETE" });
    setRighe(r => r.filter(x => x.id !== id));
    setMsg("✅ Eliminato");
    setTimeout(() => setMsg(""), 3000);
  };

  const aggiungi = async () => {
    const vals = pulisciValori(nuovoForm);
    for (const f of campiForm) {
      if (!vals[f]) { setMsg("Compila tutti i campi"); return; }
    }
    await fetch(`${API}${endpoint}`, {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify(vals),
    });
    const aggiornato = await fetch(`${API}${endpoint}`).then(r => r.json());
    setRighe(aggiornato);
    const init = {};
    campiForm.forEach(f => { init[f] = ""; });
    setNuovoForm(init);
    setMostraForm(false);
    setMsg("✅ Aggiunto");
    setTimeout(() => setMsg(""), 3000);
  };

  const leghePres = [...new Set(righe.map(r => r.lega))].sort();
  const legheFiltrate = filtroLega === "Tutti" ? leghePres : leghePres.filter(l => l === filtroLega);
  const campiFiltro = campiForm.filter(f => f !== "lega");

  const nomeDbScritto = (nuovoForm.nome_db || "").trim();
  const nomeSconosciuto = !!(nuovoForm.lega && nomeDbScritto
    && nomiDb.length > 0 && !nomiDb.includes(nomeDbScritto));
  const nomiSimili = (() => {
    if (!nomeSconosciuto) return [];
    const n = nomeDbScritto.toLowerCase();
    const parole = n.split(/[^a-z0-9]+/i).filter(w => w.length >= 4);
    return nomiDb.filter(x => {
      const y = x.toLowerCase();
      if (y.includes(n) || n.includes(y)) return true;
      return parole.some(w => y.includes(w));
    }).slice(0, 3);
  })();

  return (
    <div>
      <BannerRichiamoSetup testo={bannerTesto} onNavigate={onNavigate} />
      <div style={S.guidaBox}>{guida}</div>

      {/* Toolbar */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, flexWrap: "wrap", gap: 8 }}>
        <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 12, color: "#64748B", fontWeight: 600 }}>Campionato:</span>
          <select style={{ ...S.select, width: "auto", minWidth: 200 }}
            value={filtroLega} onChange={e => setFiltroLega(e.target.value)}>
            <option value="Tutti">Tutti i campionati</option>
            {leghePres.map(l => <option key={l} value={l}>{l}</option>)}
          </select>
        </div>
        {!mostraForm && (
          <button style={S.btnAggiungi} onClick={() => setMostraForm(true)}>+ Aggiungi voce</button>
        )}
      </div>

      {/* Form aggiungi */}
      {mostraForm && (
        <div style={{ background: "#F8FAFC", borderRadius: 8, padding: 16, border: "1px solid #E2E8F0", marginBottom: 16 }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#1E293B", marginBottom: 12 }}>Nuova voce</div>
          <div style={{ display: "flex", gap: 8, flexWrap: "wrap", alignItems: "flex-end" }}>
            {campiForm.map(f => (
              <div key={f} style={{ flex: 1, minWidth: 140 }}>
                <div style={{ fontSize: 11, color: "#64748B", marginBottom: 3 }}>{campiLabels[f]}</div>
                {f === "lega" ? (
                  <select style={S.select} value={nuovoForm[f] || ""}
                    onChange={e => setNuovoForm(v => ({ ...v, [f]: e.target.value }))}>
                    <option value="">— Seleziona —</option>
                    {LEGHE.map(l => <option key={l} value={l}>{l}</option>)}
                  </select>
                ) : (
                  <input style={S.input} value={nuovoForm[f] || ""}
                    onChange={e => setNuovoForm(v => ({ ...v, [f]: e.target.value }))} />
                )}
              </div>
            ))}
          </div>
          {nomeSconosciuto && (
            <div style={{
              marginTop: 12, background: "#FFFBEB", border: "1px solid #FCD34D",
              borderRadius: 6, padding: "10px 12px", fontSize: 13,
              color: "#92400E", lineHeight: 1.5,
            }}>
              ⚠️ Nel database non esiste nessuna squadra con questo nome in questo campionato.
              Se la squadra è appena arrivata è normale; altrimenti controlla il nome.
              {nomiSimili.length > 0 && (
                <> Simili trovati: <strong>{nomiSimili.join(" · ")}</strong></>
              )}
            </div>
          )}
          <div style={{ marginTop: 12, display: "flex", gap: 8 }}>
            <button style={S.btnSalva} onClick={aggiungi}>Aggiungi</button>
            <button style={S.btnAnnulla} onClick={() => setMostraForm(false)}>Annulla</button>
          </div>
        </div>
      )}

      {/* Tabella con leghe collassabili */}
      <div style={S.card}>
        <table style={S.tabella}>
          <thead>
            <tr>
              {colonne.map(c => <th key={c} style={S.th}>{c}</th>)}
              <th style={S.th}>Azioni</th>
            </tr>
          </thead>
          <tbody>
            {legheFiltrate.map(lega => {
              const aperta = legheAperte[lega] !== false;
              const righeL = righe.filter(r => r.lega === lega);
              return [
                <tr key={`hdr-${lega}`} style={{ background: "#EFF6FF", cursor: "pointer" }}
                  onClick={() => setLegheAperte(s => ({ ...s, [lega]: !aperta }))}>
                  <td colSpan={colonne.length + 1} style={{
                    padding: "8px 14px", fontSize: 11, fontWeight: 700, color: "#2563EB",
                    letterSpacing: "0.04em", textTransform: "uppercase",
                  }}>
                    {aperta ? "▼" : "▶"} {lega} {!aperta && `(${righeL.length})`}
                  </td>
                </tr>,
                ...(aperta ? righeL.map(riga => (
                  <tr key={riga.id}>
                    {campiFiltro.map(f => (
                      <td key={f} style={S.td}>
                        {editId === riga.id
                          ? <input style={S.input} value={editVals[f] || ""}
                              onChange={e => setEditVals(v => ({ ...v, [f]: e.target.value }))} />
                          : riga[f]}
                      </td>
                    ))}
                    <td style={S.tdAzioni}>
                      {editId === riga.id ? (
                        <>
                          <button style={S.btnSalva} onClick={() => salva(riga.id)}>Salva</button>
                          <button style={S.btnAnnulla} onClick={() => setEditId(null)}>Annulla</button>
                        </>
                      ) : (
                        <>
                          <button style={S.btnModifica} onClick={() => {
                            setEditId(riga.id);
                            const v = {};
                            campiForm.forEach(f => { v[f] = riga[f] || ""; });
                            setEditVals(v);
                          }}>✏️ Modifica</button>
                          <button style={S.btnElimina} onClick={() => elimina(riga.id)}>🗑 Elimina</button>
                        </>
                      )}
                    </td>
                  </tr>
                )) : [])
              ];
            })}
          </tbody>
        </table>
        {msg && <div style={msg.startsWith("✅") ? S.msgOk : S.msgErr}>{msg}</div>}
      </div>
    </div>
  );
}


// ─── Pagina principale ───────────────────────────────────────────────────────

const TABS = [
  { id: "num-squadre", label: "🔢 Numero Squadre" },
  { id: "mapping-betfair", label: "⬇️ Mapping Betfair → DB" },
  { id: "mapping-soccerstat", label: "⬆️ Mapping DB → SoccerSTATs" },
];

export default function Impostazioni({ onNavigate }) {
  const [tabAttiva, setTabAttiva] = useState("num-squadre");

  return (
    <div style={S.pagina}>
      <h1 style={{ fontSize: 22, fontWeight: 700, color: "#1E293B", marginBottom: 4, letterSpacing: "-0.02em" }}>
        🔧 Impostazioni
      </h1>
      <p style={{ fontSize: 13, color: "#64748B", marginBottom: 24 }}>
        Configura i parametri e le impostazioni generali della piattaforma.
      </p>

      <div style={S.tabBar}>
        {TABS.map(t => (
          <button key={t.id} style={S.tab(tabAttiva === t.id)} onClick={() => setTabAttiva(t.id)}>
            {t.label}
          </button>
        ))}
      </div>

      {tabAttiva === "num-squadre" && <SezioneNumSquadre onNavigate={onNavigate} />}

      {tabAttiva === "mapping-betfair" && (
        <SezioneMapping
          bannerTesto={<><strong>Qui si esegue la Fase 3 della procedura di setup.</strong> Quando hai finito, segna la fase come fatta in Setup nuova stagione.</>}
          guida={
            <span>
              <strong>A cosa serve:</strong> Le quote vengono scaricate dall'archivio Investisport Quote con i nomi Betfair. Se Betfair usa un nome diverso da quello nel database, inserisci qui la corrispondenza.<br /><br />
              <strong>Quando aggiornare:</strong> A inizio stagione, se una squadra promossa ha un nome Betfair diverso dal nome atteso nel database. La pipeline ti avviserà via mail con i nomi non trovati.
            </span>
          }
          endpoint="/impostazioni/mapping-betfair-db"
          colonne={["Nome Betfair (bucket)", "Nome nel DB"]}
          campiForm={["lega", "nome_betfair", "nome_db"]}
          campiLabels={{ lega: "Campionato", nome_betfair: "Nome Betfair (archivio quote)", nome_db: "Nome nel database" }}
          onNavigate={onNavigate}
        />
      )}

      {tabAttiva === "mapping-soccerstat" && (
        <SezioneMapping
          bannerTesto={<><strong>Qui si esegue la Fase 4 della procedura di setup.</strong> Quando hai finito, segna la fase come fatta in Setup nuova stagione.</>}
          guida={
            <span>
              <strong>A cosa serve:</strong> La pipeline scarica i risultati da SoccerSTATs. Se SoccerSTATs usa un nome diverso da quello nel database, inserisci qui la corrispondenza.<br /><br />
              <strong>Quando aggiornare:</strong> A inizio stagione, se una squadra promossa o rinominata ha un nome diverso su SoccerSTATs rispetto al nome nel database. La pipeline ti avviserà via mail con i nomi non trovati.
            </span>
          }
          endpoint="/impostazioni/mapping-db-soccerstat"
          colonne={["Nome nel DB", "Nome su SoccerSTATs"]}
          campiForm={["lega", "nome_db", "nome_soccerstat"]}
          campiLabels={{ lega: "Campionato", nome_db: "Nome nel database", nome_soccerstat: "Nome su SoccerSTATs" }}
          onNavigate={onNavigate}
        />
      )}
    </div>
  );
}
